﻿export default class CommandsControl {
    constructor(options) {
        this.parentType = options.parentType;
        this.localization = options.localization;
        this.id = options.id;
        this.idEntity = options.idEntity;
        this.rootUrl = options.rootUrl;
        this.commandsListId = options.commandsListId;
        this.commandWrapperId = options.commandWrapperId;
        this.commandGridDataUrl = options.commandGridDataUrl;
        this.commandSaveUrl = options.commandSaveUrl;
        this.parentControl = options.parentControl;
        this.commandsGridIdTracker = -1;
        this.currentCommandId = null;
        this.commandSource = null;
        this.fromContents = {};
        this.queryBuilderInited = false;

        this.editJs = null;
        this.editCs = null;
        this.editSql = null;

        this._initControl();
    }

    _initControl() {
        $('#' + this.commandsListId).kendoGrid({
            noRecords: true,
            messages: {
                noRecords: this._getResource('Grid_NoRecord')
            },
            sortable: true,
            pageable: {
                refresh: true,
                pageSizes: true,
                buttonCount: 5
            },
            toolbar: ["search", {
                name: 'addEntityFormCommand',
                text: this._getResource('Add'),
                iconClass: 'fal fa-plus-square',
                attr: 'class="grid-primary"'
            }],
            columns: [{
                field: 'Name',
                title: this._getResource('CommandName'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' }
            }, {
                field: 'Description',
                title: this._getResource('CommandDescription'),
                width: '10rem',
                attributes: {
                    minWidth: '10rem',
                    canBeHidden: 'false',
                    style: 'text-align: center'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' }
            }, {
                field: 'Type',
                title: this._getResource('CommandType'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' }
            }, {
                command: [
                    {
                        attr: 'title="' + this._getResource('Edit') + '" class="grid-primary" style="width:2rem;"',
                        name: 'editCommand',
                        text: '',
                        iconClass: 'fal fa-pencil',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#' + this.commandsListId).data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            this._showEntityFormCommandModal(item);
                        }
                    },
                    {
                        attr: 'title="' + this._getResource('Delete') + '" class="grid-danger" style="width:2rem; margin-left: 0.35rem;"',
                        name: 'removeCommand',
                        text: '',
                        iconClass: 'fal fa-times',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#' + this.commandsListId).data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            var items = $('#' + this.commandsListId).data('kendoGrid').dataSource.data();

                            var newItems = [];

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].Id != item.Id) {
                                    newItems.push(items[i]);
                                }
                            }

                            this.commandSource = this._createGridDatasource(newItems, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);

                        }
                    },
                    {
                        attr: 'title="' + this._getResource('Down') + '" class="grid-primary" style="width:2rem; margin-left: 0.35rem;"',
                        name: 'downCommand',
                        text: '',
                        iconClass: 'fal fa-arrow-down',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#' + this.commandsListId).data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));
                            this._moveRowDown(item.parent().indexOf(item));
                        },
                        visible: function (e) {
                            return commandsControl.commandSource.data().indexOf(e) < commandsControl.commandSource.data().length - 1;
                        }
                    },
                    {
                        attr: 'title="' + this._getResource('Up') + '" class="grid-primary" style="width:2rem; margin-left: 0.35rem;"',
                        name: 'upCommand',
                        text: '',
                        iconClass: 'fal fa-arrow-up',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#' + this.commandsListId).data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));
                            this._moveRowUp(item.parent().indexOf(item));
                        },
                        visible: function (e) {
                            return commandsControl.commandSource.data().indexOf(e) != 0;
                        }
                    }
                ],
                title: '',
                width: '4.5rem',
                attributes: {
                    minWidth: '4.5rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; justify-content: center; padding: 0.2rem;'
                }
            }
            ],
            dataBound: (evt) => {
                $('.k-grid-addEntityFormCommand').addClass('ml-auto');
            }
        });

        this._loadCommandsGrid();

        $('.k-pager-refresh').on('click', (evt) => {
            this._loadCommandsGrid();
        });

        $('.k-grid-addEntityFormCommand').on('click', (evt) => {
            evt.preventDefault();
            this._showEntityFormCommandModal(null);
        });
    }

    _loadCommandsGrid() {
        kendo.ui.progress($('#' + this.commandsListId), true);
        $.ajax({
            async: true,
            type: 'GET',
            contentType: "application/json; charset=utf-8",
            url: this.commandGridDataUrl + this.id,
            success: (result) => {
                this.commandSource = this._createGridDatasource(result, {
                    pageSize: 10,
                    page: 1
                });
                $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);
                kendo.ui.progress($('#' + this.commandsListId), false);
            },
            error: (e) => {
                kendo.ui.progress($('#' + this.commandsListId), false);
            }
        });
    }

    _createGridDatasource(items, opts) {
        var datasource = new kendo.data.DataSource({
            data: items,
            pageSize: opts.pageSize,
            page: opts.page
        });
        datasource.read();
        return datasource;
    }

    _showEntityFormCommandModal(item) {
        $('#' + this.commandWrapperId)[0].innerHTML = `<div class="pr" id="command-item-details-inner"></div>`;

        let htmlWindowOptions = {
            draggable: false,
            resizable: true,
            width: "60%",
            height: "auto",
            title: this._getResource('CommandDetails'),
            modal: true,
            close: () => { this._closeEntityFormCommandModal(); }
        };

        $('#command-item-details-inner').kendoWindow(htmlWindowOptions);
        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }
        this.queryBuilderInited = false;
        this._initEntityFormCommandModal(item);
        $('#command-item-details-inner').data("kendoWindow").center();
    }

    _closeEntityFormCommandModal() {
        $('#command-item-details-inner').data("kendoWindow").destroy();
    }

    _saveEntityFormCommandModal() {
        var commandName = $('#entity-form-command-name').val();
        var commandType = $('#entity-form-command-type').data('kendoComboBox').value();
        var commandRunType = $('#entity-form-run-type').data('kendoComboBox').value();
        var commandPermType = $('#entity-form-perm-type').data('kendoComboBox').value();
        var commandIdDbConn = $('#entity-form-command-dbconn-sql').data('kendoComboBox').value();
        var commandDescription = $('#entity-form-command-description').val();

        var commandCondition = null;
        if (this.queryBuilderInited) {
            let queryConditions = $('#entity-form-command-condition').queryBuilder('getRules');
            if (queryConditions != null) {
                commandCondition = JSON.stringify(queryConditions);
            }
        }
        var commandContent = '';

        switch (commandType) {
            case 'SEND_EMAIL': {
                let emailContents = {};
                emailContents.Subject = $('#entity-form-command-email-subject').val();
                emailContents.Body = $('#entity-form-command-email-body').val();
                emailContents.Multiply = $('#email-multiply-list').data('kendoGrid').dataSource.data().toJSON();
                emailContents.To = $('#email-to-list').data('kendoGrid').dataSource.data().toJSON();
                emailContents.Cc = $('#email-cc-list').data('kendoGrid').dataSource.data().toJSON();
                emailContents.Bcc = $('#email-bcc-list').data('kendoGrid').dataSource.data().toJSON();
                emailContents.From = this.fromContents;

                commandContent = JSON.stringify(emailContents);
                break;
            }
            case 'CLIENT': {
                commandContent = this.editJs.getValue();
                break;
            }
            case 'C_SHARP_WITH_RESULT':
            case 'C_SHARP_NO_RESULT': {
                commandContent = this.editCs.getValue();
                break;
            }
            case 'SERVER_WITH_RESULT': 
            case 'SERVER_NO_RESULT': {
                commandContent = this.editSql.getValue();
                break;
            }
        }
        //if (commandType == 'SEND_EMAIL') {
        //    let emailContents = {};
        //    emailContents.Subject = $('#entity-form-command-email-subject').val();
        //    emailContents.Body = $('#entity-form-command-email-body').val();
        //    emailContents.Multiply = $('#email-multiply-list').data('kendoGrid').dataSource.data().toJSON();
        //    emailContents.To = $('#email-to-list').data('kendoGrid').dataSource.data().toJSON();
        //    emailContents.Cc = $('#email-cc-list').data('kendoGrid').dataSource.data().toJSON();
        //    emailContents.Bcc = $('#email-bcc-list').data('kendoGrid').dataSource.data().toJSON();
        //    emailContents.From = this.fromContents;

        //    commandContent = JSON.stringify(emailContents);
        //}
        //else {
        //    commandContent = $('#entity-form-command-content').val();
        //    commandContent = this.htmlPrintingTemplate.getValue();
        //}

        if (commandName != null && commandName.trim() != '' && commandType != null && commandType.trim() != '' && commandContent != null && commandContent.trim() != '') {
            var item = {
                Name: commandName,
                Type: commandType,
                Description: commandDescription,
                Condition: commandCondition,
                Content: commandContent,
                RunType: commandRunType,
                PermReqType: commandPermType,
                IdEntity: this.idEntity,
                IdDbConn: commandIdDbConn
            };

            if (this.currentCommandId != null) {
                item.Id = this.currentCommandId;

                var items = $('#' + this.commandsListId).data('kendoGrid').dataSource.data();

                for (var i = 0; i < items.length; i++) {
                    if (items[i].Id == item.Id) {
                        items[i].Name = item.Name;
                        items[i].Type = item.Type;
                        items[i].Description = item.Description;
                        items[i].Condition = item.Condition;
                        items[i].Content = item.Content;
                        items[i].RunType = item.RunType;
                        items[i].PermReqType = item.PermReqType;
                        items[i].IdEntity = item.IdEntity;
                        items[i].IdDbConn = item.IdDbConn;
                    }
                }
                this.commandSource = this._createGridDatasource(items, {
                    pageSize: 10,
                    page: 1
                });

                $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);
            } else {
                item.Id = this.commandsGridIdTracker;
                this.commandsGridIdTracker--;

                var items = $('#' + this.commandsListId).data('kendoGrid').dataSource.data();
                items.push(item);

                this.commandSource = this._createGridDatasource(items, {
                    pageSize: 10,
                    page: 1
                });

                $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);
            }

            this._closeEntityFormCommandModal();
        }
    }

    _getCommandTypeDataSource() {
        if (this.parentType == 'entity') {
            return [
                { Definition: this._getResource('CommandType_SERVER_NO_RESULT'), Id: 'SERVER_NO_RESULT' },
                { Definition: this._getResource('CommandType_SEND_EMAIL'), Id: 'SEND_EMAIL' },
                { Definition: this._getResource('CommandType_C_SHARP_NO_RESULT'), Id: 'C_SHARP_NO_RESULT' }
            ];
        } else {
            return [
                { Definition: this._getResource('CommandType_CLIENT'), Id: 'CLIENT' },
                { Definition: this._getResource('CommandType_SERVER_WITH_RESULT'), Id: 'SERVER_WITH_RESULT' },
                { Definition: this._getResource('CommandType_C_SHARP_WITH_RESULT'), Id: 'C_SHARP_WITH_RESULT' },
                { Definition: this._getResource('CommandType_SERVER_NO_RESULT'), Id: 'SERVER_NO_RESULT' },
                { Definition: this._getResource('CommandType_C_SHARP_NO_RESULT'), Id: 'C_SHARP_NO_RESULT' },
                { Definition: this._getResource('CommandType_SEND_EMAIL'), Id: 'SEND_EMAIL' }
            ];
        }
    }

    _getCommandRunTypeDataSource() {
        if (this.parentType == 'entity') {
            return [{
                Definition: this._getResource('RunType_AFTER_SAVE'),
                Id: 'AFTER_SAVE'
            }];
        } else {
            return [{
                Definition: this._getResource('RunType_MANUAL'),
                Id: 'MANUAL'
            }, {
                Definition: this._getResource('RunType_AFTER_SAVE'),
                Id: 'AFTER_SAVE'
            }];
        }
    }

    _initEntityFormCommandModal(item) {
        var template = `<div class="form-row">
                <div class="col-xl-3 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandName') + `</label>
                        <input type="text" id="entity-form-command-name" class="form-control">
                        <span id="entity-form-command-name-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
                <div class="col-xl-3 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandType') + `</label>
                        <div id="entity-form-command-type" class="form-control"></div>
                        <span id="entity-form-command-type-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
                <div class="col-xl-3 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('RunType') + `</label>
                        <div id="entity-form-run-type" class="form-control"></div>
                        <span id="entity-form-command-run-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
                <div class="col-xl-3 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('PermType') + `</label>
                        <div id="entity-form-perm-type" class="form-control"></div>
                        <span id="entity-form-command-perm-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandDescription') + `</label>
                        <textarea id="entity-form-command-description" class="form-control"></textarea>
                        <span id="entity-form-command-description-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-row" id="command-trigger-condition" style="display: none;">
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandCondition') + `</label>
                        <div id="entity-form-command-condition"></div>
                        <span id="entity-form-command-condition-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-row" id="raw-command-content" style="display: none;">
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandContent') + `</label>
                        <textarea id="entity-form-command-content" class="form-control" style="height: 400px; display: none"></textarea>
                        <div class="form-control" id="entity-form-command-content-ace" style="width: 100%; height: 350px;"></div>
                        <span id="entity-form-command-content-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-row" id="js-command-content" style="display: none;">
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('DbConn') + `</label>
                        <div class="form-control" id="entity-form-command-content-js" style="width: 100%; height: 350px;"></div>
                        <span id="entity-form-command-content-js-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-row" id="cs-command-content" style="display: none;">
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandContent') + `</label>
                        <div class="form-control" id="entity-form-command-content-cs" style="width: 100%; height: 350px;"></div>
                        <span id="entity-form-command-content-cs-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div id="sql-command-content" style="display: none;">
                <div class="form-row">
                    <div class="col-xl-12 mb-3">
                        <div class="form-group">
                            <label class="form-label" help-key="EntityForm.XpCommand.DbConn">` + this._getResource('DbConn') + `</label>
                            <div class="form-control" id="entity-form-command-dbconn-sql" style="width: 100%;"></div>
                            <span id="entity-form-command-dbconn-sql-validation" class="invalid-feedback">
                            </span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-xl-12 mb-3">
                        <div class="form-group">
                            <label class="form-label" help-key="EntityForm.XpCommand.ContentSql">` + this._getResource('CommandContent') + `</label>
                            <div class="form-control" id="entity-form-command-content-sql" style="width: 100%; height: 350px;"></div>
                            <span id="entity-form-command-content-sql-validation" class="invalid-feedback">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row" id="email-command-content" style="display: none;">
                <div class="accordion accordion-outline col-12 pb-0" id="email-multiply" style="padding-bottom: 1rem;">
                    <div class="card">
                        <div class="card-header" style="height: 2.25rem;">
                            <a href="javascript:void(0);" class="card-title collapsed" data-toggle="collapse" data-target="#email-multiply-body" aria-expanded="false" style="padding: 0.5rem 0.5rem;">
                                ` + this._getResource('CommandEmailMultiply') + `
                                <span class="ml-auto">
                                    <span class="collapsed-reveal">
                                        <i class="fal fa-minus fs-xl"></i>
                                    </span>
                                    <span class="collapsed-hidden">
                                        <i class="fal fa-plus fs-xl"></i>
                                    </span>
                                </span>
                            </a>
                        </div>
                        <div id="email-multiply-body" class="collapse" data-parent="#email-multiply">
                            <div class="card-body">
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <div class="form-group m-0" id="email-multiply-list">
                                        </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               <div class="accordion accordion-outline col-12 pb-0" id="email-from" style="padding-bottom: 1rem;">
                    <div class="card">
                        <div class="card-header" style="height: 2.25rem;">
                            <a href="javascript:void(0);" class="card-title collapsed" data-toggle="collapse" data-target="#email-from-body" aria-expanded="false" style="padding: 0.5rem 0.5rem;">
                                ` + this._getResource('CommandEmailFrom') + `
                                <span class="ml-auto">
                                    <span class="collapsed-reveal">
                                        <i class="fal fa-minus fs-xl"></i>
                                    </span>
                                    <span class="collapsed-hidden">
                                        <i class="fal fa-plus fs-xl"></i>
                                    </span>
                                </span>
                            </a>
                        </div>
                        <div id="email-from-body" class="collapse" data-parent="#email-from">
                            <div class="card-body">
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <div class="form-row">
                                            <div class="col-xl-4">
                                                <div id="cbox-from-type" class="form-control"></div>
                                            </div>
                                            <textarea type="text" id="from-sql-value" class="form-control col-xl-8" style="display:none; height: 2.3rem;"></textarea>
                                            <div class="col-xl-2 from-is-field-value" style="display:none;">
                                                <div class="form-group mt-2" style="padding-left: 2.5rem;">
                                                    <label class="form-label">` + this._getResource('MultiplyIsField') + `</label>
                                                    <div id="from-is-field-value"></div>
                                                </div>
                                            </div>
                                            <input type="text" id="from-value-value" class="form-control col-xl-6" style="display:none;"/>
                                            <div class="col-xl-6 from-field-value" style="display:none;">
                                                <div class="form-group">
                                                    <input type="text" id="from-field-value" class="form-control"/>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 from-field-choice" style="display:none;">
                                                <div class="form-group">
                                                    <div id="from-field-choice" class="form-control"></div>
                                                </div>
                                            </div>
                                        </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandEmailTo') + `</label>
                        <div class="form-group m-0" id="email-to-list">
                        </div>
                        </span>
                    </div>
                </div>
                <div class="accordion accordion-outline col-12 pb-0" id="email-cc" style="padding-bottom: 1rem;">
                    <div class="card">
                        <div class="card-header" style="height: 2.25rem;">
                            <a href="javascript:void(0);" class="card-title collapsed" data-toggle="collapse" data-target="#email-cc-body" aria-expanded="false" style="padding: 0.5rem 0.5rem;">
                                ` + this._getResource('CommandEmailCc') + `
                                <span class="ml-auto">
                                    <span class="collapsed-reveal">
                                        <i class="fal fa-minus fs-xl"></i>
                                    </span>
                                    <span class="collapsed-hidden">
                                        <i class="fal fa-plus fs-xl"></i>
                                    </span>
                                </span>
                            </a>
                        </div>
                        <div id="email-cc-body" class="collapse" data-parent="#email-cc">
                            <div class="card-body">
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <div class="form-group m-0" id="email-cc-list">
                                        </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion accordion-outline col-12 pb-0" id="email-bcc" style="padding-bottom: 1rem;">
                    <div class="card">
                        <div class="card-header" style="height: 2.25rem;">
                            <a href="javascript:void(0);" class="card-title collapsed" data-toggle="collapse" data-target="#email-bcc-body" aria-expanded="false" style="padding: 0.5rem 0.5rem;">
                                ` + this._getResource('CommandEmailBcc') + `
                                <span class="ml-auto">
                                    <span class="collapsed-reveal">
                                        <i class="fal fa-minus fs-xl"></i>
                                    </span>
                                    <span class="collapsed-hidden">
                                        <i class="fal fa-plus fs-xl"></i>
                                    </span>
                                </span>
                            </a>
                        </div>
                        <div id="email-bcc-body" class="collapse" data-parent="#email-bcc">
                            <div class="card-body">
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <div class="form-group m-0" id="email-bcc-list">
                                        </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandEmailSubject') + `</label>
                        <input type="text" id="entity-form-command-email-subject" class="form-control"/>
                        <span id="entity-form-command-email-subject-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label class="form-label">` + this._getResource('CommandEmailBody') + `</label>
                        <textarea id="entity-form-command-email-body" class="form-control"></textarea>
                        <span id="entity-form-command-email-body-validation" class="invalid-feedback">
                        </span>
                    </div>
                </div>
            </div>
            <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0" style="padding-top: 1.2rem;">
                    <button class="btn btn-secondary ml-auto" onclick="commandsControl._closeEntityFormCommandModal();" title="` + this._getResource('CancelChanges') + `" type="button">` + this._getResource('Cancel') + `</button>
                    <button class="btn btn-primary ml-2" onclick="commandsControl._saveEntityFormCommandModal();" title="` + this._getResource('SaveChanged') + `" type="button">` + this._getResource('Save') + `</button>
            </div>`;

        $('#command-item-details-inner')[0].innerHTML = template;

        $('#entity-form-command-type').kendoComboBox({
            dataTextField: 'Definition',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getCommandTypeDataSource(),
            change: (e) => {
                this._setContentVisibility(e.sender.value());
                
                //if (e.sender.value() == 'SEND_EMAIL') {
                //    $('#raw-command-content').hide();
                //    $('#email-command-content').show();
                //} else {
                //    $('#raw-command-content').show();
                //    $('#email-command-content').hide();
                //}

                if (this.parentType != 'entity') {
                    $('#entity-form-run-type').data('kendoComboBox').value(null);
                }
                if (e.sender.value() == 'CLIENT' || e.sender.value() == 'SERVER_WITH_RESULT' || e.sender.value() == 'C_SHARP_WITH_RESULT') {
                    var cbo = $('#entity-form-run-type').data('kendoComboBox');
                    cbo.dataSource.data([{ Definition: this._getResource('RunType_MANUAL'), Id: 'MANUAL' }]);
                    cbo.value('MANUAL');
                } else {
                    $('#entity-form-run-type').data('kendoComboBox').dataSource.data(this._getCommandRunTypeDataSource());
                }
                //$('#entity-form-perm-type').data('kendoComboBox').dataSource.data(this._getCommandPermTypeDataSource());

                if (this.parentType != 'entity') {
                    $('#entity-form-run-type').data('kendoComboBox').trigger('change');
                }
            }
        });

        $('#entity-form-run-type').kendoComboBox({
            dataTextField: 'Definition',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getCommandRunTypeDataSource(),
            change: (e) => {
                if (e.sender.value() == 'AFTER_SAVE') {
                    $('#command-trigger-condition').show();
                    this._initQueryBuilder(item);
                } else {
                    $('#command-trigger-condition').hide();
                    if (item != null) {
                        item.Condition = null;
                    }
                }
            }
        });

        $('#entity-form-perm-type').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetXpCommandPermReqType';
                        }
                    }
                }
            },
            change: (e) => {

            }
        });

        $('#entity-form-command-dbconn-sql').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'DbConn/GetDbConns';
                        }
                    }
                }
            },
            change: (e) => {

            }
        });

        this.editJs = ace.edit('entity-form-command-content-js', {
            mode: "ace/mode/javascript",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.editCs = ace.edit('entity-form-command-content-cs', {
            mode: "ace/mode/csharp",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.editSql = ace.edit('entity-form-command-content-sql', {
            mode: "ace/mode/sql",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });


        if (item != null) {
            this.currentCommandId = item.Id;

            $('#entity-form-command-name').val(item.Name);
            $('#entity-form-command-type').data('kendoComboBox').value(item.Type);

            if (item.RunType == null) {
                item.RunType = 'MANUAL';
                $('#entity-form-run-type').data('kendoComboBox').value('MANUAL');
            } else {
                $('#entity-form-run-type').data('kendoComboBox').value(item.RunType);
            }
            $('#entity-form-perm-type').data('kendoComboBox').value(item.PermReqType);
            $('#entity-form-command-dbconn-sql').data('kendoComboBox').value(item.IdDbConn);

            if (item.RunType == 'MANUAL') {
                $('#command-trigger-condition').hide();
            } else {
                $('#command-trigger-condition').show();
                this._initQueryBuilder(item);
            }

            this._initEmail(item);

            this._setContentVisibility(item.Type);

            this.editJs.setValue('');
            this.editCs.setValue('');
            this.editSql.setValue('');

            switch (item.Type) {
                case 'SEND_EMAIL': {
                    //$('#email-command-content').show();
                    //$('#raw-command-content').hide();

                    if (item.Content != null) {
                        let emailContents = JSON.parse(item.Content);
                        this.fromContents = emailContents.From != null ? emailContents.From : {};

                        if (this.fromContents.Field != null) {
                            $('#from-field-choice').data('kendoComboBox').value(this.fromContents.Field);
                        }

                        if (this.fromContents.Id != null) {
                            $('#from-field-value').val(this.fromContents.Id);
                        }

                        if (this.fromContents.Sql != null) {
                            $('#from-sql-value').val(this.fromContents.Sql);
                        }

                        if (this.fromContents.Value != null) {
                            $('#from-value-value').val(this.fromContents.Value);
                        }

                        if (this.fromContents.Type != null) {
                            $('#cbox-from-type').data('kendoComboBox').value(this.fromContents.Type);

                            if (this.fromContents.Type == 'USER_EMAIL' || this.fromContents.Type == 'ROLE_USERS') {
                                $('.from-is-field-value').show();

                                if (this.fromContents.Id == null) {
                                    $('.from-field-value').hide();
                                    $('.from-field-choice').show();
                                    $('#from-is-field-value').data('kendoSwitch').check(true);
                                } else {
                                    $('.from-field-value').show();
                                    $('.from-field-choice').hide();
                                    $('#from-is-field-value').data('kendoSwitch').check(false);
                                }
                            } else if (this.fromContents.Type == 'SQL') {
                                $('#from-sql-value').show();
                            } else if (this.fromContents.Type == 'EMAIL') {
                                $('.from-is-field-value').show();

                                if (this.fromContents.Value == null) {
                                    $('#from-value-value').hide();
                                    $('.from-field-choice').show();
                                    $('#from-is-field-value').data('kendoSwitch').check(true);
                                } else {
                                    $('#from-value-value').show();
                                    $('.from-field-choice').hide();
                                    $('#from-is-field-value').data('kendoSwitch').check(false);
                                }
                            }
                        }

                        if (emailContents.Subject != null && emailContents.Subject.trim() != '') {
                            $('#entity-form-command-email-subject').val(emailContents.Subject);
                        }

                        if (emailContents.Body != null && emailContents.Body.trim() != '') {
                            $('#entity-form-command-email-body').val(emailContents.Body);
                        }
                        if (emailContents.Multiply == null) {
                            emailContents.Multiply = [];
                        }
                        if (emailContents.Multiply != null && emailContents.Multiply.length > 0) {
                            let dataSource = this._createGridDatasource(emailContents.Multiply, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-multiply-list').data('kendoGrid').setDataSource(dataSource);
                        }

                        if (emailContents.To == null) {
                            emailContents.To = [];
                        }

                        if (emailContents.To != null && emailContents.To.length > 0) {
                            let dataSource = this._createGridDatasource(emailContents.To, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-to-list').data('kendoGrid').setDataSource(dataSource);
                        }

                        if (emailContents.Cc == null) {
                            emailContents.Cc = [];
                        }
                        if (emailContents.Cc != null && emailContents.Cc.length > 0) {
                            let dataSource = this._createGridDatasource(emailContents.Cc, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-cc-list').data('kendoGrid').setDataSource(dataSource);
                        }

                        if (emailContents.Bcc == null) {
                            emailContents.Bcc = [];
                        }

                        if (emailContents.Bcc != null && emailContents.Bcc.length > 0) {
                            let dataSource = this._createGridDatasource(emailContents.Bcc, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-bcc-list').data('kendoGrid').setDataSource(dataSource);
                        }
                    }
                    break;
                }
                case 'CLIENT': {
                    this.editJs.setValue(item.Content);
                    break;
                }
                case 'C_SHARP_WITH_RESULT': 
                case 'C_SHARP_NO_RESULT': {
                    this.editCs.setValue(item.Content);
                    break;
                }
                case 'SERVER_WITH_RESULT': 
                case 'SERVER_NO_RESULT': {
                    this.editSql.setValue(item.Content);
                    break;
                }
            }

            $('#entity-form-command-description').val(item.Description);
        } else {
            this._initEmail(null);
            this.currentCommandId = null;

            if (this.parentType == 'entity') {
                $('#entity-form-run-type').data('kendoComboBox').value('AFTER_SAVE');
                $('#entity-form-run-type').data('kendoComboBox').trigger('change');
            } else {
                $('#entity-form-run-type').data('kendoComboBox').value('MANUAL');
                $('#entity-form-run-type').data('kendoComboBox').trigger('change');
            }
        }
        addHelp();
    }

    _setContentVisibility(type) {
        switch (type) {
            case 'SEND_EMAIL': {
                $('#raw-command-content').hide();
                $('#js-command-content').hide();
                $('#cs-command-content').hide();
                $('#sql-command-content').hide();
                $('#email-command-content').show();
                break;
            }
            case 'CLIENT': {
                $('#raw-command-content').hide();
                $('#js-command-content').show();
                $('#cs-command-content').hide();
                $('#sql-command-content').hide();
                $('#email-command-content').hide();
                break;
            }
            case 'SERVER_WITH_RESULT':
            case 'SERVER_NO_RESULT': {
                $('#raw-command-content').hide();
                $('#js-command-content').hide();
                $('#cs-command-content').hide();
                $('#sql-command-content').show();
                $('#email-command-content').hide();
                break;
            }
            case 'C_SHARP_WITH_RESULT': 
            case 'C_SHARP_NO_RESULT': {
                $('#raw-command-content').hide();
                $('#js-command-content').hide();
                $('#cs-command-content').show();
                $('#sql-command-content').hide();
                $('#email-command-content').hide();
                break;
            }
        }
    }

    _initEmail(item) {
        if (item == null) {
            item = {};
        }
        this._createMultiplyGrid(item);
        this._createToGrid(item);
        this._createCcGrid(item);
        this._createBccGrid(item);

        $('#cbox-from-type').kendoComboBox({
            dataTextField: 'Definition',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: [
                { Definition: this._getResource('EmailType_TARGET_EMAIL'), Id: 'TARGET_EMAIL' },
                { Definition: this._getResource('EmailType_CURRENT_USER_EMAIL'), Id: 'CURRENT_USER_EMAIL' },
                { Definition: this._getResource('EmailType_USER_EMAIL'), Id: 'USER_EMAIL' },
                { Definition: this._getResource('EmailType_EMAIL'), Id: 'EMAIL' },
                { Definition: this._getResource('EmailType_SQL'), Id: 'SQL' },
                { Definition: this._getResource('EmailType_ROLE_USERS'), Id: 'ROLE_USERS' }
            ],
            change: (e) => {
                this.fromContents.Type = e.sender.value();
                switch (e.sender.value()) {
                    case 'TARGET_EMAIL': {
                        $('#from-sql-value').hide();
                        $('#from-value-value').hide();
                        $('.from-is-field-value').hide();
                        $('.from-field-value').hide();
                        $('.from-field-choice').hide();
                    }
                        break;
                    case 'CURRENT_USER_EMAIL': {
                        $('#from-sql-value').hide();
                        $('#from-value-value').hide();
                        $('.from-is-field-value').hide();
                        $('.from-field-value').hide();
                        $('.from-field-choice').hide();
                    }
                        break;
                    case 'USER_EMAIL': {
                        $('#from-sql-value').hide();
                        $('#from-value-value').hide();
                        $('.from-is-field-value').show();

                        if (this.fromContents.Field == null || this.fromContents.Field != '') {
                            $('.from-field-value').hide();
                            $('.from-field-choice').show();
                        } else {
                            $('.from-field-value').show();
                            $('.from-field-choice').hide();
                        }
                    }
                        break;
                    case 'EMAIL': {
                        $('#from-sql-value').hide();
                        $('.from-field-value').hide();
                        $('.from-is-field-value').show();

                        if (this.fromContents.Field == null || this.fromContents.Field != '') {
                            $('#from-value-value').hide();
                            $('.from-field-choice').show();
                        } else {
                            $('#from-value-value').show();
                            $('.from-field-choice').hide();
                        }
                    }
                        break;
                    case 'SQL': {
                        $('#from-sql-value').show();
                        $('#from-value-value').hide();
                        $('.from-is-field-value').hide();
                        $('.from-field-value').hide();
                        $('.from-field-choice').hide();
                    }
                        break;
                    case 'ROLE_USERS': {
                        $('#from-sql-value').hide();
                        $('#from-value-value').hide();
                        $('.from-is-field-value').show();

                        if (this.fromContents.Field == null || this.fromContents.Field != '') {
                            $('.from-field-value').hide();
                            $('.from-field-choice').show();
                        } else {
                            $('.from-field-value').show();
                            $('.from-field-choice').hide();
                        }
                    }
                        break;
                    default: {
                        $('#from-value-value').hide();
                        $('#from-sql-value').hide();
                        $('.from-is-field-value').hide();
                        $('.from-field-value').hide();
                        $('.from-field-choice').hide();
                    }
                        break;
                }
            }
        });

        $('#from-is-field-value').kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: true,
            change: (e) => {
                if (this.fromContents.Type == 'EMAIL') {
                    if (e.checked) {
                        $('#from-value-value').hide();
                        $('.from-field-choice').show();
                        this.fromContents.Value = null;
                    } else {
                        $('#from-value-value').show();
                        $('.from-field-choice').hide();
                        this.fromContents.Field = null;
                    }
                } else {
                    if (e.checked) {
                        $('.from-field-value').hide();
                        $('.from-field-choice').show();
                        this.fromContents.Id = null;
                    } else {
                        $('.from-field-value').show();
                        $('.from-field-choice').hide();
                        this.fromContents.Field = null;
                    }
                }
            }
        });

        $('#from-field-choice').kendoComboBox({
            dataTextField: 'FieldName',
            dataValueField: 'FieldName',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return this.rootUrl + 'Entity/GetFields?id=' + this.idEntity;
                        }
                    }
                }
            },
            change: (e) => {
                this.fromContents.Field = e.sender.value();
            }
        });

        $('#from-field-value').on('keyup', (e) => {
            this.fromContents.Id = $('#from-field-value').val();
        });

        $('#from-sql-value').on('keyup', (e) => {
            this.fromContents.Sql = $('#from-sql-value').val();
        });

        $('#from-value-value').on('keyup', (e) => {
            this.fromContents.Value = $('#from-value-value').val();
        });
    }

    _createMultiplyGrid(item) {
        $('#email-multiply-list').kendoGrid({
            noRecords: true,
            messages: {
                noRecords: this._getResource('Grid_NoRecord')
            },
            columns: [{
                field: 'Type',
                title: this._getResource('MultiplyType'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' },
                template: (e) => {
                    return '<div id="cbox-multiply-type-' + e.uid + '" class="form-control"></div>';
                }
            }, {
                field: 'Value',
                title: this._getResource('MultiplyValue'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                template: (e) => {
                    return `<textarea type="text" id="multiply-sql-value-` + e.uid + `" class="form-control" style="display:none;"></textarea>
                            <div class="form-row">
                                <div class="col-xl-4 multiply-is-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group mt-2">
                                        <label class="form-label">` + this._getResource('MultiplyIsField') + `</label>
                                        <div id="multiply-is-field-value-` + e.uid + `"></div>
                                    </div>
                                </div>
                                <div class="col-xl-8 multiply-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="multiply-field-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 multiply-field-choice-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <div id="multiply-field-choice-` + e.uid + `" class="form-control"></div>
                                    </div>
                                </div>
                            </div>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' }
            }, {
                command: [
                    {
                        attr: 'title="' + this._getResource('Delete') + '" class="grid-danger" style="width:2rem;"',
                        name: 'removeMultiply',
                        text: '',
                        iconClass: 'fal fa-times',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#email-multiply-list').data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            var items = $('#email-multiply-list').data('kendoGrid').dataSource.data();
                            var newItems = [];

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].uid != item.uid) {
                                    newItems.push(items[i]);
                                }
                            }

                            let dataSource = this._createGridDatasource(newItems, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-multiply-list').data('kendoGrid').setDataSource(dataSource);
                        }
                    }],
                title: '',
                width: '2.5rem',
                attributes: {
                    minWidth: '2.5rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; justify-content: center; padding: 0.2rem;'
                },
                headerTemplate: (e) => {
                    return `<button class="btn grid-primary fal fa-plus-square" onclick="commandsControl._addMultiply()" style="padding: 0.35rem 0.5rem 0.35rem 0.5rem !important; font-size: 1rem; margin-left: 0.25rem;"></button>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; padding: 0.25rem;' }
            }],
            dataBound: (e) => {
                e.sender.dataItems().forEach(item => {
                    $('#cbox-multiply-type-' + item.uid).kendoComboBox({
                        dataTextField: 'Definition',
                        dataValueField: 'Id',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: [
                            { Definition: this._getResource('MultiplyType_CURRENT_USER'), Id: 'CURRENT_USER' },
                            { Definition: this._getResource('MultiplyType_USER'), Id: 'USER' },
                            { Definition: this._getResource('MultiplyType_SQL'), Id: 'SQL' },
                            { Definition: this._getResource('MultiplyType_ROLE_USERS'), Id: 'ROLE_USERS' }
                        ],
                        change: (e) => {
                            item.Type = e.sender.value();
                            switch (e.sender.value()) {
                                case 'CURRENT_USER': {
                                    $('#multiply-sql-value-' + item.uid).hide();
                                    $('.multiply-is-field-value-' + item.uid).hide();
                                    $('.multiply-field-value-' + item.uid).hide();
                                    $('.multiply-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'USER': {
                                    $('#multiply-sql-value-' + item.uid).hide();
                                    $('.multiply-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.multiply-field-value-' + item.uid).hide();
                                        $('.multiply-field-choice-' + item.uid).show();
                                    } else {
                                        $('.multiply-field-value-' + item.uid).show();
                                        $('.multiply-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'SQL': {
                                    $('#multiply-sql-value-' + item.uid).show();
                                    $('.multiply-is-field-value-' + item.uid).hide();
                                    $('.multiply-field-value-' + item.uid).hide();
                                    $('.multiply-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'ROLE_USERS': {
                                    $('#multiply-sql-value-' + item.uid).hide();
                                    $('.multiply-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.multiply-field-value-' + item.uid).hide();
                                        $('.multiply-field-choice-' + item.uid).show();
                                    } else {
                                        $('.multiply-field-value-' + item.uid).show();
                                        $('.multiply-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                default: {
                                    $('#multiply-sql-value-' + item.uid).hide();
                                    $('.multiply-is-field-value-' + item.uid).hide();
                                    $('.multiply-field-value-' + item.uid).hide();
                                    $('.multiply-field-choice-' + item.uid).hide();
                                }
                                    break;
                            }
                        }
                    });

                    if (item.Type != null) {
                        $('#cbox-multiply-type-' + item.uid).data('kendoComboBox').value(item.Type);

                        if (item.Type == 'USER' || item.Type == 'ROLE_USERS') {
                            $('.multiply-is-field-value-' + item.uid).show();

                            if (item.Id == null) {
                                $('.multiply-field-value-' + item.uid).hide();
                                $('.multiply-field-choice-' + item.uid).show();
                            } else {
                                $('.multiply-field-value-' + item.uid).show();
                                $('.multiply-field-choice-' + item.uid).hide();
                            }
                        } else if (item.Type == 'SQL') {
                            $('#multiply-sql-value-' + item.uid).show();
                        }
                    }

                    $('#multiply-is-field-value-' + item.uid).kendoSwitch({
                        messages: {
                            checked: this._getResource('SWITCH_ON'),
                            unchecked: this._getResource('SWITCH_OFF')
                        },
                        checked: true,
                        change: (e) => {
                            if (e.checked) {
                                $('.multiply-field-value-' + item.uid).hide();
                                $('.multiply-field-choice-' + item.uid).show();
                                item.Id = null;
                            } else {
                                $('.multiply-field-value-' + item.uid).show();
                                $('.multiply-field-choice-' + item.uid).hide();
                                item.Field = null;
                            }
                        }
                    });

                    if (item.Id == null) {
                        $('#multiply-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                    } else {
                        $('#multiply-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                    }

                    $('#multiply-field-value-' + item.uid).on('keyup', (e) => {
                        item.Id = $('#multiply-field-value-' + item.uid).val();
                    });

                    $('#multiply-sql-value-' + item.uid).on('keyup', (e) => {
                        item.Sql = $('#multiply-sql-value-' + item.uid).val();
                    });

                    $('#multiply-field-choice-' + item.uid).kendoComboBox({
                        dataTextField: 'FieldName',
                        dataValueField: 'FieldName',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: {
                            serverFiltering: true,
                            transport: {
                                read: {
                                    dataType: 'json',
                                    url: () => {
                                        return this.rootUrl + 'Entity/GetFields?id=' + this.idEntity;
                                    }
                                }
                            }
                        },
                        change: (e) => {
                            item.Field = e.sender.value();
                        }
                    });

                    if (item.Field != null) {
                        $('#multiply-field-choice-' + item.uid).data('kendoComboBox').value(item.Field);
                    }

                    if (item.Id != null) {
                        $('#multiply-field-value-' + item.uid).val(item.Id);
                    }

                    if (item.Sql != null) {
                        $('#multiply-sql-value-' + item.uid).val(item.Sql);
                    }
                });
            }
        });
    }

    _addMultiply() {
        let items = $('#email-multiply-list').data('kendoGrid').dataSource.data();

        items.push({
            Type: null,
            Field: null,
            Sql: null,
            Id: null
        });

        let dataSource = this._createGridDatasource(items, {
            pageSize: 10,
            page: 1
        });

        $('#email-multiply-list').data('kendoGrid').setDataSource(dataSource);
    }

    _createToGrid(item) {
        $('#email-to-list').kendoGrid({
            noRecords: true,
            messages: {
                noRecords: this._getResource('Grid_NoRecord')
            },
            columns: [{
                field: 'Type',
                title: this._getResource('EmailType'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' },
                template: (e) => {
                    return '<div id="cbox-to-type-' + e.uid + '" class="form-control"></div>';
                }
            }, {
                field: 'Value',
                title: this._getResource('MultiplyValue'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                template: (e) => {
                    return `<textarea type="text" id="to-sql-value-` + e.uid + `" class="form-control" style="display:none;"></textarea>
                            <div class="form-row">
                                <div class="col-xl-4 to-is-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group mt-2">
                                        <label class="form-label">` + this._getResource('MultiplyIsField') + `</label>
                                        <div id="to-is-field-value-` + e.uid + `"></div>
                                    </div>
                                </div>
                                <div class="col-xl-8 to-value-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="to-value-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 to-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="to-field-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 to-field-choice-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <div id="to-field-choice-` + e.uid + `" class="form-control"></div>
                                    </div>
                                </div>
                            </div>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' }
            }, {
                command: [
                    {
                        attr: 'title="' + this._getResource('Delete') + '" class="grid-danger" style="width:2rem;"',
                        name: 'removeTo',
                        text: '',
                        iconClass: 'fal fa-times',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#email-to-list').data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            var items = $('#email-to-list').data('kendoGrid').dataSource.data();
                            var newItems = [];

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].uid != item.uid) {
                                    newItems.push(items[i]);
                                }
                            }

                            let dataSource = this._createGridDatasource(newItems, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-to-list').data('kendoGrid').setDataSource(dataSource);
                        }
                    }],
                title: '',
                width: '2.5rem',
                attributes: {
                    minWidth: '2.5rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; justify-content: center; padding: 0.2rem;'
                },
                headerTemplate: (e) => {
                    return `<button class="btn grid-primary fal fa-plus-square" onclick="commandsControl._addTo()" style="padding: 0.35rem 0.5rem 0.35rem 0.5rem !important; font-size: 1rem; margin-left: 0.25rem;"></button>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; padding: 0.25rem;' }
            }],
            dataBound: (e) => {
                e.sender.dataItems().forEach(item => {
                    $('#cbox-to-type-' + item.uid).kendoComboBox({
                        dataTextField: 'Definition',
                        dataValueField: 'Id',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: [
                            { Definition: this._getResource('EmailType_TARGET_EMAIL'), Id: 'TARGET_EMAIL' },
                            { Definition: this._getResource('EmailType_CURRENT_USER_EMAIL'), Id: 'CURRENT_USER_EMAIL' },
                            { Definition: this._getResource('EmailType_USER_EMAIL'), Id: 'USER_EMAIL' },
                            { Definition: this._getResource('EmailType_EMAIL'), Id: 'EMAIL' },
                            { Definition: this._getResource('EmailType_SQL'), Id: 'SQL' },
                            { Definition: this._getResource('EmailType_ROLE_USERS'), Id: 'ROLE_USERS' }
                        ],
                        change: (e) => {
                            item.Type = e.sender.value();
                            switch (e.sender.value()) {
                                case 'TARGET_EMAIL': {
                                    $('#to-sql-value-' + item.uid).hide();
                                    $('.to-value-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).hide();
                                    $('.to-field-value-' + item.uid).hide();
                                    $('.to-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'CURRENT_USER_EMAIL': {
                                    $('#to-sql-value-' + item.uid).hide();
                                    $('.to-value-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).hide();
                                    $('.to-field-value-' + item.uid).hide();
                                    $('.to-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'USER_EMAIL': {
                                    $('#to-sql-value-' + item.uid).hide();
                                    $('.to-value-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.to-field-value-' + item.uid).hide();
                                        $('.to-field-choice-' + item.uid).show();
                                    } else {
                                        $('.to-field-value-' + item.uid).show();
                                        $('.to-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'EMAIL': {
                                    $('#to-sql-value-' + item.uid).hide();
                                    $('.to-field-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.to-value-value-' + item.uid).hide();
                                        $('.to-field-choice-' + item.uid).show();
                                    } else {
                                        $('.to-value-value-' + item.uid).show();
                                        $('.to-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'SQL': {
                                    $('#to-sql-value-' + item.uid).show();
                                    $('.to-value-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).hide();
                                    $('.to-field-value-' + item.uid).hide();
                                    $('.to-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'ROLE_USERS': {
                                    $('#to-sql-value-' + item.uid).hide();
                                    $('.to-value-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.to-field-value-' + item.uid).hide();
                                        $('.to-field-choice-' + item.uid).show();
                                    } else {
                                        $('.to-field-value-' + item.uid).show();
                                        $('.to-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                default: {
                                    $('.to-value-value-' + item.uid).hide();
                                    $('#to-sql-value-' + item.uid).hide();
                                    $('.to-is-field-value-' + item.uid).hide();
                                    $('.to-field-value-' + item.uid).hide();
                                    $('.to-field-choice-' + item.uid).hide();
                                }
                                    break;
                            }
                        }
                    });

                    if (item.Type != null) {
                        $('#cbox-to-type-' + item.uid).data('kendoComboBox').value(item.Type);

                        if (item.Type == 'USER_EMAIL' || item.Type == 'ROLE_USERS') {
                            $('.to-is-field-value-' + item.uid).show();

                            if (item.Id == null) {
                                $('.to-field-value-' + item.uid).hide();
                                $('.to-field-choice-' + item.uid).show();
                            } else {
                                $('.to-field-value-' + item.uid).show();
                                $('.to-field-choice-' + item.uid).hide();
                            }
                        } else if (item.Type == 'SQL') {
                            $('#to-sql-value-' + item.uid).show();
                        } else if (item.Type == 'EMAIL') {
                            $('.to-is-field-value-' + item.uid).show();

                            if (item.Value == null) {
                                $('.to-value-value-' + item.uid).hide();
                                $('.to-field-choice-' + item.uid).show();
                            } else {
                                $('.to-value-value-' + item.uid).show();
                                $('.to-field-choice-' + item.uid).hide();
                            }
                        }
                    }

                    $('#to-is-field-value-' + item.uid).kendoSwitch({
                        messages: {
                            checked: this._getResource('SWITCH_ON'),
                            unchecked: this._getResource('SWITCH_OFF')
                        },
                        checked: true,
                        change: (e) => {
                            if (item.Type == 'EMAIL') {
                                if (e.checked) {
                                    $('.to-value-value-' + item.uid).hide();
                                    $('.to-field-choice-' + item.uid).show();
                                    item.Value = null;
                                } else {
                                    $('.to-value-value-' + item.uid).show();
                                    $('.to-field-choice-' + item.uid).hide();
                                    item.Field = null;
                                }
                            }
                            else {
                                if (e.checked) {
                                    $('.to-field-value-' + item.uid).hide();
                                    $('.to-field-choice-' + item.uid).show();
                                    item.Id = null;
                                } else {
                                    $('.to-field-value-' + item.uid).show();
                                    $('.to-field-choice-' + item.uid).hide();
                                    item.Field = null;
                                }
                            }
                        }
                    });

                    if (item.Type == 'EMAIL') {
                        if (item.Value == null) {
                            $('#to-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                        } else {
                            $('#to-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                        }
                    } else {
                        if (item.Id == null) {
                            $('#to-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                        } else {
                            $('#to-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                        }
                    }

                    $('#to-field-value-' + item.uid).on('keyup', (e) => {
                        item.Id = $('#to-field-value-' + item.uid).val();
                    });

                    $('#to-sql-value-' + item.uid).on('keyup', (e) => {
                        item.Sql = $('#to-sql-value-' + item.uid).val();
                    });

                    $('#to-value-value-' + item.uid).on('keyup', (e) => {
                        item.Value = $('#to-value-value-' + item.uid).val();
                    });

                    $('#to-field-choice-' + item.uid).kendoComboBox({
                        dataTextField: 'FieldName',
                        dataValueField: 'FieldName',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: {
                            serverFiltering: true,
                            transport: {
                                read: {
                                    dataType: 'json',
                                    url: () => {
                                        return this.rootUrl + 'Entity/GetFields?id=' + this.idEntity;
                                    }
                                }
                            }
                        },
                        change: (e) => {
                            item.Field = e.sender.value();
                        }
                    });

                    if (item.Field != null) {
                        $('#to-field-choice-' + item.uid).data('kendoComboBox').value(item.Field);
                    }

                    if (item.Id != null) {
                        $('#to-field-value-' + item.uid).val(item.Id);
                    }

                    if (item.Sql != null) {
                        $('#to-sql-value-' + item.uid).val(item.Sql);
                    }

                    if (item.Value != null) {
                        $('#to-value-value-' + item.uid).val(item.Value);
                    }
                });
            }
        });
    }

    _addTo() {
        let items = $('#email-to-list').data('kendoGrid').dataSource.data();

        items.push({
            Type: null,
            Field: null,
            Sql: null,
            Id: null,
            Value: null
        });

        let dataSource = this._createGridDatasource(items, {
            pageSize: 10,
            page: 1
        });

        $('#email-to-list').data('kendoGrid').setDataSource(dataSource);
    }

    _createCcGrid(item) {
        $('#email-cc-list').kendoGrid({
            noRecords: true,
            messages: {
                noRecords: this._getResource('Grid_NoRecord')
            },
            columns: [{
                field: 'Type',
                title: this._getResource('EmailType'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' },
                template: (e) => {
                    return '<div id="cbox-cc-type-' + e.uid + '" class="form-control"></div>';
                }
            }, {
                field: 'Value',
                title: this._getResource('MultiplyValue'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                template: (e) => {
                    return `<textarea type="text" id="cc-sql-value-` + e.uid + `" class="form-control" style="display:none;"></textarea>
                            <div class="form-row">
                                <div class="col-xl-4 cc-is-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group mt-2">
                                        <label class="form-label">` + this._getResource('MultiplyIsField') + `</label>
                                        <div id="cc-is-field-value-` + e.uid + `"></div>
                                    </div>
                                </div>
                                <div class="col-xl-8 cc-value-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="cc-value-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 cc-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="cc-field-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 cc-field-choice-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <div id="cc-field-choice-` + e.uid + `" class="form-control"></div>
                                    </div>
                                </div>
                            </div>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' }
            }, {
                command: [
                    {
                        attr: 'title="' + this._getResource('Delete') + '" class="grid-danger" style="width:2rem;"',
                        name: 'removeCc',
                        text: '',
                        iconClass: 'fal fa-times',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#email-cc-list').data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            var items = $('#email-cc-list').data('kendoGrid').dataSource.data();
                            var newItems = [];

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].uid != item.uid) {
                                    newItems.push(items[i]);
                                }
                            }

                            let dataSource = this._createGridDatasource(newItems, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-cc-list').data('kendoGrid').setDataSource(dataSource);
                        }
                    }],
                title: '',
                width: '2.5rem',
                attributes: {
                    minWidth: '2.5rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; justify-content: center; padding: 0.2rem;'
                },
                headerTemplate: (e) => {
                    return `<button class="btn grid-primary fal fa-plus-square" onclick="commandsControl._addCc()" style="padding: 0.35rem 0.5rem 0.35rem 0.5rem !important; font-size: 1rem; margin-left: 0.25rem;"></button>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; padding: 0.25rem;' }
            }],
            dataBound: (e) => {
                e.sender.dataItems().forEach(item => {
                    $('#cbox-cc-type-' + item.uid).kendoComboBox({
                        dataTextField: 'Definition',
                        dataValueField: 'Id',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: [
                            { Definition: this._getResource('EmailType_TARGET_EMAIL'), Id: 'TARGET_EMAIL' },
                            { Definition: this._getResource('EmailType_CURRENT_USER_EMAIL'), Id: 'CURRENT_USER_EMAIL' },
                            { Definition: this._getResource('EmailType_USER_EMAIL'), Id: 'USER_EMAIL' },
                            { Definition: this._getResource('EmailType_EMAIL'), Id: 'EMAIL' },
                            { Definition: this._getResource('EmailType_SQL'), Id: 'SQL' },
                            { Definition: this._getResource('EmailType_ROLE_USERS'), Id: 'ROLE_USERS' }
                        ],
                        change: (e) => {
                            item.Type = e.sender.value();
                            switch (e.sender.value()) {
                                case 'TARGET_EMAIL': {
                                    $('#cc-sql-value-' + item.uid).hide();
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).hide();
                                    $('.cc-field-value-' + item.uid).hide();
                                    $('.cc-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'CURRENT_USER_EMAIL': {
                                    $('#cc-sql-value-' + item.uid).hide();
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).hide();
                                    $('.cc-field-value-' + item.uid).hide();
                                    $('.cc-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'USER_EMAIL': {
                                    $('#cc-sql-value-' + item.uid).hide();
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.cc-field-value-' + item.uid).hide();
                                        $('.cc-field-choice-' + item.uid).show();
                                    } else {
                                        $('.cc-field-value-' + item.uid).show();
                                        $('.cc-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'EMAIL': {
                                    $('#cc-sql-value-' + item.uid).hide();
                                    $('.cc-field-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.cc-value-value-' + item.uid).hide();
                                        $('.cc-field-choice-' + item.uid).show();
                                    } else {
                                        $('.cc-value-value-' + item.uid).show();
                                        $('.cc-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'SQL': {
                                    $('#cc-sql-value-' + item.uid).show();
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).hide();
                                    $('.cc-field-value-' + item.uid).hide();
                                    $('.cc-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'ROLE_USERS': {
                                    $('#cc-sql-value-' + item.uid).hide();
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.cc-field-value-' + item.uid).hide();
                                        $('.cc-field-choice-' + item.uid).show();
                                    } else {
                                        $('.cc-field-value-' + item.uid).show();
                                        $('.cc-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                default: {
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('#cc-sql-value-' + item.uid).hide();
                                    $('.cc-is-field-value-' + item.uid).hide();
                                    $('.cc-field-value-' + item.uid).hide();
                                    $('.cc-field-choice-' + item.uid).hide();
                                }
                                    break;
                            }
                        }
                    });

                    if (item.Type != null) {
                        $('#cbox-cc-type-' + item.uid).data('kendoComboBox').value(item.Type);

                        if (item.Type == 'USER_EMAIL' || item.Type == 'ROLE_USERS') {
                            $('.cc-is-field-value-' + item.uid).show();

                            if (item.Id == null) {
                                $('.cc-field-value-' + item.uid).hide();
                                $('.cc-field-choice-' + item.uid).show();
                            } else {
                                $('.cc-field-value-' + item.uid).show();
                                $('.cc-field-choice-' + item.uid).hide();
                            }
                        } else if (item.Type == 'SQL') {
                            $('#cc-sql-value-' + item.uid).show();
                        } else if (item.Type == 'EMAIL') {
                            $('.cc-is-field-value-' + item.uid).show();

                            if (item.Value == null) {
                                $('.cc-value-value-' + item.uid).hide();
                                $('.cc-field-choice-' + item.uid).show();
                            } else {
                                $('.cc-value-value-' + item.uid).show();
                                $('.cc-field-choice-' + item.uid).hide();
                            }
                        }
                    }

                    $('#cc-is-field-value-' + item.uid).kendoSwitch({
                        messages: {
                            checked: this._getResource('SWITCH_ON'),
                            unchecked: this._getResource('SWITCH_OFF')
                        },
                        checked: true,
                        change: (e) => {
                            if (item.Type == 'EMAIL') {
                                if (e.checked) {
                                    $('.cc-value-value-' + item.uid).hide();
                                    $('.cc-field-choice-' + item.uid).show();
                                    item.Value = null;
                                } else {
                                    $('.cc-value-value-' + item.uid).show();
                                    $('.cc-field-choice-' + item.uid).hide();
                                    item.Field = null;
                                }
                            }
                            else {
                                if (e.checked) {
                                    $('.cc-field-value-' + item.uid).hide();
                                    $('.cc-field-choice-' + item.uid).show();
                                    item.Id = null;
                                } else {
                                    $('.cc-field-value-' + item.uid).show();
                                    $('.cc-field-choice-' + item.uid).hide();
                                    item.Field = null;
                                }
                            }
                        }
                    });

                    if (item.Type == 'EMAIL') {
                        if (item.Value == null) {
                            $('#cc-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                        } else {
                            $('#cc-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                        }
                    } else {
                        if (item.Id == null) {
                            $('#cc-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                        } else {
                            $('#cc-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                        }
                    }

                    $('#cc-field-value-' + item.uid).on('keyup', (e) => {
                        item.Id = $('#cc-field-value-' + item.uid).val();
                    });

                    $('#cc-sql-value-' + item.uid).on('keyup', (e) => {
                        item.Sql = $('#cc-sql-value-' + item.uid).val();
                    });

                    $('#cc-value-value-' + item.uid).on('keyup', (e) => {
                        item.Value = $('#cc-value-value-' + item.uid).val();
                    });

                    $('#cc-field-choice-' + item.uid).kendoComboBox({
                        dataTextField: 'FieldName',
                        dataValueField: 'FieldName',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: {
                            serverFiltering: true,
                            transport: {
                                read: {
                                    dataType: 'json',
                                    url: () => {
                                        return this.rootUrl + 'Entity/GetFields?id=' + this.idEntity;
                                    }
                                }
                            }
                        },
                        change: (e) => {
                            item.Field = e.sender.value();
                        }
                    });

                    if (item.Field != null) {
                        $('#cc-field-choice-' + item.uid).data('kendoComboBox').value(item.Field);
                    }

                    if (item.Id != null) {
                        $('#cc-field-value-' + item.uid).val(item.Id);
                    }

                    if (item.Sql != null) {
                        $('#cc-sql-value-' + item.uid).val(item.Sql);
                    }

                    if (item.Value != null) {
                        $('#cc-value-value-' + item.uid).val(item.Value);
                    }
                });
            }
        });
    }

    _addCc() {
        let items = $('#email-cc-list').data('kendoGrid').dataSource.data();

        items.push({
            Type: null,
            Field: null,
            Sql: null,
            Id: null,
            Value: null
        });

        let dataSource = this._createGridDatasource(items, {
            pageSize: 10,
            page: 1
        });

        $('#email-cc-list').data('kendoGrid').setDataSource(dataSource);
    }

    _createBccGrid(item) {
        $('#email-bcc-list').kendoGrid({
            noRecords: true,
            messages: {
                noRecords: this._getResource('Grid_NoRecord')
            },
            columns: [{
                field: 'Type',
                title: this._getResource('EmailType'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' },
                template: (e) => {
                    return '<div id="cbox-bcc-type-' + e.uid + '" class="form-control"></div>';
                }
            }, {
                field: 'Value',
                title: this._getResource('MultiplyValue'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; padding: 0.2rem;'
                },
                template: (e) => {
                    return `<textarea type="text" id="bcc-sql-value-` + e.uid + `" class="form-control" style="display:none;"></textarea>
                            <div class="form-row">
                                <div class="col-xl-4 bcc-is-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group mt-2">
                                        <label class="form-label">` + this._getResource('MultiplyIsField') + `</label>
                                        <div id="bcc-is-field-value-` + e.uid + `"></div>
                                    </div>
                                </div>
                                <div class="col-xl-8 bcc-value-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="bcc-value-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 bcc-field-value-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <input type="text" id="bcc-field-value-` + e.uid + `" class="form-control"/>
                                    </div>
                                </div>
                                <div class="col-xl-8 bcc-field-choice-` + e.uid + `" style="display:none;">
                                    <div class="form-group">
                                        <div id="bcc-field-choice-` + e.uid + `" class="form-control"></div>
                                    </div>
                                </div>
                            </div>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; line-height: 1.65rem; padding: 0.25rem;' }
            }, {
                command: [
                    {
                        attr: 'title="' + this._getResource('Delete') + '" class="grid-danger" style="width:2rem;"',
                        name: 'removeBcc',
                        text: '',
                        iconClass: 'fal fa-times',
                        click: (e) => {
                            e.preventDefault();
                            var item = $('#email-bcc-list').data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            var items = $('#email-bcc-list').data('kendoGrid').dataSource.data();
                            var newItems = [];

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].uid != item.uid) {
                                    newItems.push(items[i]);
                                }
                            }

                            let dataSource = this._createGridDatasource(newItems, {
                                pageSize: 10,
                                page: 1
                            });

                            $('#email-bcc-list').data('kendoGrid').setDataSource(dataSource);
                        }
                    }],
                title: '',
                width: '2.5rem',
                attributes: {
                    minWidth: '2.5rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; justify-content: center; padding: 0.2rem;'
                },
                headerTemplate: (e) => {
                    return `<button class="btn grid-primary fal fa-plus-square" onclick="commandsControl._addBcc()" style="padding: 0.35rem 0.5rem 0.35rem 0.5rem !important; font-size: 1rem; margin-left: 0.25rem;"></button>`;
                },
                headerAttributes: { style: 'text-align: center; justify-content: center; padding: 0.25rem;' }
            }],
            dataBound: (e) => {
                e.sender.dataItems().forEach(item => {
                    $('#cbox-bcc-type-' + item.uid).kendoComboBox({
                        dataTextField: 'Definition',
                        dataValueField: 'Id',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: [
                            { Definition: this._getResource('EmailType_TARGET_EMAIL'), Id: 'TARGET_EMAIL' },
                            { Definition: this._getResource('EmailType_CURRENT_USER_EMAIL'), Id: 'CURRENT_USER_EMAIL' },
                            { Definition: this._getResource('EmailType_USER_EMAIL'), Id: 'USER_EMAIL' },
                            { Definition: this._getResource('EmailType_EMAIL'), Id: 'EMAIL' },
                            { Definition: this._getResource('EmailType_SQL'), Id: 'SQL' },
                            { Definition: this._getResource('EmailType_ROLE_USERS'), Id: 'ROLE_USERS' }
                        ],
                        change: (e) => {
                            item.Type = e.sender.value();
                            switch (e.sender.value()) {
                                case 'TARGET_EMAIL': {
                                    $('#bcc-sql-value-' + item.uid).hide();
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).hide();
                                    $('.bcc-field-value-' + item.uid).hide();
                                    $('.bcc-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'CURRENT_USER_EMAIL': {
                                    $('#bcc-sql-value-' + item.uid).hide();
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).hide();
                                    $('.bcc-field-value-' + item.uid).hide();
                                    $('.bcc-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'USER_EMAIL': {
                                    $('#bcc-sql-value-' + item.uid).hide();
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.bcc-field-value-' + item.uid).hide();
                                        $('.bcc-field-choice-' + item.uid).show();
                                    } else {
                                        $('.bcc-field-value-' + item.uid).show();
                                        $('.bcc-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'EMAIL': {
                                    $('#bcc-sql-value-' + item.uid).hide();
                                    $('.bcc-field-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.bcc-value-value-' + item.uid).hide();
                                        $('.bcc-field-choice-' + item.uid).show();
                                    } else {
                                        $('.bcc-value-value-' + item.uid).show();
                                        $('.bcc-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                case 'SQL': {
                                    $('#bcc-sql-value-' + item.uid).show();
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).hide();
                                    $('.bcc-field-value-' + item.uid).hide();
                                    $('.bcc-field-choice-' + item.uid).hide();
                                }
                                    break;
                                case 'ROLE_USERS': {
                                    $('#bcc-sql-value-' + item.uid).hide();
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).show();

                                    if (item.Field == null || item.Field != '') {
                                        $('.bcc-field-value-' + item.uid).hide();
                                        $('.bcc-field-choice-' + item.uid).show();
                                    } else {
                                        $('.bcc-field-value-' + item.uid).show();
                                        $('.bcc-field-choice-' + item.uid).hide();
                                    }
                                }
                                    break;
                                default: {
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('#bcc-sql-value-' + item.uid).hide();
                                    $('.bcc-is-field-value-' + item.uid).hide();
                                    $('.bcc-field-value-' + item.uid).hide();
                                    $('.bcc-field-choice-' + item.uid).hide();
                                }
                                    break;
                            }
                        }
                    });

                    if (item.Type != null) {
                        $('#cbox-bcc-type-' + item.uid).data('kendoComboBox').value(item.Type);

                        if (item.Type == 'USER_EMAIL' || item.Type == 'ROLE_USERS') {
                            $('.bcc-is-field-value-' + item.uid).show();

                            if (item.Id == null) {
                                $('.bcc-field-value-' + item.uid).hide();
                                $('.bcc-field-choice-' + item.uid).show();
                            } else {
                                $('.bcc-field-value-' + item.uid).show();
                                $('.bcc-field-choice-' + item.uid).hide();
                            }
                        } else if (item.Type == 'SQL') {
                            $('#bcc-sql-value-' + item.uid).show();
                        } else if (item.Type == 'EMAIL') {
                            $('.bcc-is-field-value-' + item.uid).show();

                            if (item.Value == null) {
                                $('.bcc-value-value-' + item.uid).hide();
                                $('.bcc-field-choice-' + item.uid).show();
                            } else {
                                $('.bcc-value-value-' + item.uid).show();
                                $('.bcc-field-choice-' + item.uid).hide();
                            }
                        }
                    }

                    $('#bcc-is-field-value-' + item.uid).kendoSwitch({
                        messages: {
                            checked: this._getResource('SWITCH_ON'),
                            unchecked: this._getResource('SWITCH_OFF')
                        },
                        checked: true,
                        change: (e) => {
                            if (item.Type == 'EMAIL') {
                                if (e.checked) {
                                    $('.bcc-value-value-' + item.uid).hide();
                                    $('.bcc-field-choice-' + item.uid).show();
                                    item.Value = null;
                                } else {
                                    $('.bcc-value-value-' + item.uid).show();
                                    $('.bcc-field-choice-' + item.uid).hide();
                                    item.Field = null;
                                }
                            }
                            else {
                                if (e.checked) {
                                    $('.bcc-field-value-' + item.uid).hide();
                                    $('.bcc-field-choice-' + item.uid).show();
                                    item.Id = null;
                                } else {
                                    $('.bcc-field-value-' + item.uid).show();
                                    $('.bcc-field-choice-' + item.uid).hide();
                                    item.Field = null;
                                }
                            }
                        }
                    });

                    if (item.Type == 'EMAIL') {
                        if (item.Value == null) {
                            $('#bcc-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                        } else {
                            $('#bcc-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                        }
                    } else {
                        if (item.Id == null) {
                            $('#bcc-is-field-value-' + item.uid).data('kendoSwitch').check(true);
                        } else {
                            $('#bcc-is-field-value-' + item.uid).data('kendoSwitch').check(false);
                        }
                    }

                    $('#bcc-field-value-' + item.uid).on('keyup', (e) => {
                        item.Id = $('#bcc-field-value-' + item.uid).val();
                    });

                    $('#bcc-sql-value-' + item.uid).on('keyup', (e) => {
                        item.Sql = $('#bcc-sql-value-' + item.uid).val();
                    });

                    $('#bcc-value-value-' + item.uid).on('keyup', (e) => {
                        item.Value = $('#bcc-value-value-' + item.uid).val();
                    });

                    $('#bcc-field-choice-' + item.uid).kendoComboBox({
                        dataTextField: 'FieldName',
                        dataValueField: 'FieldName',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: {
                            serverFiltering: true,
                            transport: {
                                read: {
                                    dataType: 'json',
                                    url: () => {
                                        return this.rootUrl + 'Entity/GetFields?id=' + this.idEntity;
                                    }
                                }
                            }
                        },
                        change: (e) => {
                            item.Field = e.sender.value();
                        }
                    });

                    if (item.Field != null) {
                        $('#bcc-field-choice-' + item.uid).data('kendoComboBox').value(item.Field);
                    }

                    if (item.Id != null) {
                        $('#bcc-field-value-' + item.uid).val(item.Id);
                    }

                    if (item.Sql != null) {
                        $('#bcc-sql-value-' + item.uid).val(item.Sql);
                    }

                    if (item.Value != null) {
                        $('#bcc-value-value-' + item.uid).val(item.Value);
                    }
                });
            }
        });
    }

    _addBcc() {
        let items = $('#email-bcc-list').data('kendoGrid').dataSource.data();

        items.push({
            Type: null,
            Field: null,
            Sql: null,
            Id: null,
            Value: null
        });

        let dataSource = this._createGridDatasource(items, {
            pageSize: 10,
            page: 1
        });

        $('#email-bcc-list').data('kendoGrid').setDataSource(dataSource);
    }

    _initQueryBuilder(item) {
        if (!this.queryBuilderInited) {
            let filters = [];

            this.parentControl.getEntityFields().forEach((entityField) => {
                filters.push(this._getConditionFilter(entityField, 'new.', ' (New)'));
            });

            this.parentControl.getEntityFields().forEach((entityField) => {
                filters.push(this._getConditionFilter(entityField, 'old.', ' (Old)'));
            });

            filters.push({
                id: 'eval',
                label: 'eval',
                type: 'string',
                operators: ['sql'],
                input: (rule, name) => {
                    return `<textarea class="form-control" style="min-width: 44vw;"></textarea>`;
                },
                valueGetter: (rule) => {
                    return rule.$el.find('textarea').val();
                },
                valueSetter: (rule, value) => {
                    return rule.$el.find('textarea').val(value);
                }
            });

            let queryBuilderOptions = {
                filters: filters
            };

            if (item != null && item.Condition != null && item.Condition.trim() != '') {
                queryBuilderOptions.rules = JSON.parse(item.Condition);
            }

            $('#entity-form-command-condition').queryBuilder(queryBuilderOptions);

            this.queryBuilderInited = true;
        }
    }

    _getValueFieldOptions() {
        let result = '';

        this.parentControl.getEntityFields().forEach((entityField) => {
            result += '<option value="new.' + entityField.FieldName.toLocaleLowerCase() + '">' + entityField.FieldName + ' (New)</option>';
        });

        this.parentControl.getEntityFields().forEach((entityField) => {
            result += '<option value="old.' + entityField.FieldName.toLocaleLowerCase() + '">' + entityField.FieldName + ' (Old)</option>';
        });

        return result;
    }

    _getConditionFilter(entityField, prefix, labelPrefix) {
        let filter = {
            id: prefix + entityField.FieldName.toLocaleLowerCase(),
            label: entityField.FieldName + labelPrefix,
            type: 'string',
            operators: this._getFilterOperator(entityField),
            isInitialized: false,
            input: (rule, name) => {
                rule.filter.isInitialized = false;
                if (rule.operator.type == 'between') {
                    if (name.indexOf('value_0') > 0) {
                        var $container = rule.$el.find('.rule-value-container');

                        $container.on('change', '[name=' + name + '_1]', (evt) => {
                            var h = '';

                            switch ($(evt.currentTarget).val()) {
                                case 'Value':
                                    h = '<input class="form-control"/>';
                                    $container.find('[name$=_3]').html(h).toggle(true);
                                    $container.find('[name$=_2]').toggle(false);
                                    this._initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                                    rule.filter.isInitialized = true;
                                    break;
                                case 'Field':
                                    h = this._getValueFieldOptions();
                                    $container.find('[name$=_2]').html(h).toggle(true).trigger('change');
                                    $container.find('[name$=_3]').toggle(false);
                                    break;
                            }
                        });

                        return `<select class="form-control" name="` + name + `_1">
                                    <option value="Value">Value</option> 
                                    <option value="Field">Field</option>
                                </select>
                                <select class="form-control" name="`+ name + `_2" style="display:none; margin-left: 0.5rem;"></select>
                                    <div name="`+ name + `_3" style="margin-left: 0.5rem;"><input class="form-control"/></div>`;
                    } else {
                        var $container = rule.$el.find('.rule-value-container');

                        $container.on('change', '[name=' + name + '_4]', (evt) => {
                            var h = '';

                            switch ($(evt.currentTarget).val()) {
                                case 'Value':
                                    h = '<input class="form-control"/>';
                                    $container.find('[name$=_6]').html(h).toggle(true);
                                    $container.find('[name$=_5]').toggle(false);
                                    this._initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'));
                                    rule.filter.isInitialized = true;
                                    break;
                                case 'Field':
                                    h = this._getValueFieldOptions();
                                    $container.find('[name$=_5]').html(h).toggle(true).trigger('change');
                                    $container.find('[name$=_6]').toggle(false);
                                    break;
                            }
                        });

                        return `<select class="form-control" name="` + name + `_4">
                                    <option value="Value">Value</option> 
                                    <option value="Field">Field</option>
                                </select>
                                <select class="form-control" name="`+ name + `_5" style="display:none; margin-left: 0.5rem;"></select>
                                <div name="`+ name + `_6" style="margin-left: 0.5rem;"><input class="form-control"/></div>`;
                    }
                } else {
                    var $container = rule.$el.find('.rule-value-container');

                    $container.on('change', '[name=' + name + '_1]', (evt) => {
                        var h = '';

                        switch ($(evt.currentTarget).val()) {
                            case 'Value':
                                h = '<input class="form-control"/>';
                                $container.find('[name$=_3]').html(h).toggle(true);
                                $container.find('[name$=_2]').toggle(false);
                                this._initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                                rule.filter.isInitialized = true;
                                break;
                            case 'Field':
                                h = this._getValueFieldOptions();
                                $container.find('[name$=_2]').html(h).toggle(true).trigger('change');
                                $container.find('[name$=_3]').toggle(false);
                                break;
                        }
                    });

                    return `<select class="form-control" name="` + name + `_1">
                                <option value="Value">Value</option> 
                                <option value="Field">Field</option>
                            </select>
                            <select class="form-control" name="`+ name + `_2" style="display:none; margin-left: 0.5rem;"></select>
                                    <div name="`+ name + `_3" style="margin-left: 0.5rem;"><input class="form-control"/></div>`;
                }
            },
            valueGetter: (rule) => {
                return this._filterValueGetter(rule, entityField);
            },
            valueSetter: (rule, value) => {
                if (rule.operator.nb_inputs > 0) {
                    if (value != null && value.trim() != '') {
                        var val = JSON.parse(value);
                        if (rule.operator.type == 'between') {
                            rule.$el.find('.rule-value-container [name$=_1]').val(val.min.type).trigger('change');

                            if (val.min.type == 'Field') {
                                rule.$el.find('.rule-value-container [name$=_2]').val(val.min.value).trigger('change');
                            } else {
                                this._setFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'), val.min.value);
                            }

                            rule.$el.find('.rule-value-container [name$=_4]').val(val.max.type).trigger('change');

                            if (val.max.type == 'Field') {
                                rule.$el.find('.rule-value-container [name$=_5]').val(val.max.value).trigger('change');
                            } else {
                                this._setFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'), val.max.value);
                            }
                        } else {
                            rule.$el.find('.rule-value-container [name$=_1]').val(val.type).trigger('change');
                            if (val.type == 'Field') {
                                rule.$el.find('.rule-value-container [name$=_2]').val(val.value).trigger('change');
                            } else {
                                this._setFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'), val.value);
                            }
                        }
                    }
                }
            }
        }

        return filter;
    }

    _getFilterOperator(entityField) {
        switch (entityField.DataType) {
            case 'BYTEA':
            case 'GEOMETRY':
            case 'BOOLEAN':
            case 'BOOLINT':
            case 'STRING': return ['equal', 'not_equal', 'is_null', 'is_not_null'];
            case 'NUMERIC':
            case 'INTEGER':
            case 'DATE':
            case 'TIMESTAMP': return ['equal', 'not_equal', 'is_null', 'is_not_null', 'between', 'less', 'less_or_equal', 'greater', 'greater_or_equal'];
        }
    }

    _initializeFilter(rule, entityField, selector) {
        switch (entityField.DataType) {
            case 'INTEGER': {
                selector.parent().css('padding-top', '0');
                selector.kendoNumericTextBox({
                    format: "0",
                    decimals: 0,
                    change: (evt) => {
                        rule._updating_value = true;
                        rule.value = this._filterValueGetter(rule, entityField);
                    }
                });
            };
                break;
            case 'NUMERIC': {
                selector.parent().css('padding-top', '0');
                selector.kendoNumericTextBox({
                    change: (evt) => {
                        rule._updating_value = true;
                        rule.value = this._filterValueGetter(rule, entityField);
                    }
                });
            };
                break;
            case 'BOOLEAN':
            case 'BOOLINT': {
                selector.parent().css('padding-top', '0.5rem');
                selector.removeClass('form-control');
                selector.kendoSwitch({
                    change: (evt) => {
                        rule._updating_value = true;
                        rule.value = this._filterValueGetter(rule, entityField);
                    }
                });
            };
                break;
            case 'DATE': {
                selector.parent().css('padding-top', '0');
                selector.kendoDatePicker();
            }
                break;
            case 'TIMESTAMP': {
                selector.parent().css('padding-top', '0');
                selector.kendoDateTimePicker();
            }
                break;
            default: selector.parent().css('padding-top', '0');
                break;
        }
    }

    _filterValueGetter(rule, entityField) {
        if (!rule.filter.isInitialized) {
            if (rule.operator.type == 'between') {
                this._initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                this._initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'));
                rule.filter.isInitialized = true;
            }
            else {
                this._initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                rule.filter.isInitialized = true;
            }
        }

        if (rule.operator.type == 'between') {
            let minType = rule.$el.find('.rule-value-container [name$=_1]').val();
            let maxType = rule.$el.find('.rule-value-container [name$=_4]').val();
            let result = {
                min: {
                    type: minType,
                    value: minType == 'Field' ? rule.$el.find('.rule-value-container [name$=_2]').val() : this._getFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'))
                },
                max: {
                    type: maxType,
                    value: minType == 'Field' ? rule.$el.find('.rule-value-container [name$=_5]').val() : this._getFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'))
                }
            };
            return JSON.stringify(result);
        } else {
            let type = rule.$el.find('.rule-value-container [name$=_1]').val();
            let result = {
                type: type,
                value: type == 'Field' ? rule.$el.find('.rule-value-container [name$=_2]').val() : this._getFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'))
            };
            return JSON.stringify(result);
        }
    }

    _getFilterValue(entityField, selector) {
        switch (entityField.DataType) {
            case 'INTEGER': return ($(selector[1]).data('kendoNumericTextBox') != null ? $(selector[1]).data('kendoNumericTextBox').value() : null);
            case 'NUMERIC': return ($(selector[1]).data('kendoNumericTextBox') != null ? $(selector[1]).data('kendoNumericTextBox').value() : null);
            case 'BOOLEAN': return (selector.data('kendoSwitch') != null ? selector.data('kendoSwitch').check() : null);
            case 'BOOLINT': return (selector.data('kendoSwitch') != null ? (selector.data('kendoSwitch').check() ? 1 : 0) : null);
            case 'DATE': return (selector.data('kendoDatePicker') != null ? this._dateToISOString(selector.data('kendoDatePicker').value()) : null);
            case 'TIMESTAMP': return (selector.data('kendoDateTimePicker') != null ? this._dateToISOString(selector.data('kendoDateTimePicker').value()) : null);
            default: return selector.val();
        }
    }

    _dateToISOString(date) {
        if (date == null) {
            return null;
        }

        let year = date.getFullYear();
        let month = this._padDatePart(date.getMonth() + 1);
        let day = this._padDatePart(date.getDate());
        let hours = this._padDatePart(date.getHours());
        let minutes = this._padDatePart(date.getHours());
        let seconds = this._padDatePart(date.getSeconds());

        return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + '.000Z';
    }

    _padDatePart(part) {
        if (part < 10) {
            return '0' + part;
        } else {
            return part;
        }
    }

    _setFilterValue(entityField, selector, value) {
        switch (entityField.DataType) {
            case 'INTEGER': $(selector[1]).data('kendoNumericTextBox').value(value);
                break;
            case 'NUMERIC': $(selector[1]).data('kendoNumericTextBox').value(value);
                break;
            case 'BOOLEAN': selector.data('kendoSwitch').check(value);
                break;
            case 'BOOLINT': selector.data('kendoSwitch').check(value == 1);
                break;
            case 'DATE': selector.data('kendoDatePicker').value(new Date(value));
                break;
            case 'TIMESTAMP': selector.data('kendoDateTimePicker').value(new Date(value));
            default: break;
        }
    }

    _moveRowDown(idx) {
        var items = $('#' + this.commandsListId).data('kendoGrid').dataSource.data();
        this._array_move(items, idx, idx + 1);

        this.commandSource = this._createGridDatasource(items, {
            pageSize: 10,
            page: 1
        });

        $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);
    }

    _moveRowUp(idx) {
        var items = $('#' + this.commandsListId).data('kendoGrid').dataSource.data();
        this._array_move(items, idx, idx - 1);

        this.commandSource = this._createGridDatasource(items, {
            pageSize: 10,
            page: 1
        });

        $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);
    }

    _array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    }

    saveEntityCommands() {
        var items = $('#' + this.commandsListId).data('kendoGrid').dataSource.data();

        var data = {
            commands: []
        }

        if (this.parentType == 'form') {
            data.idForm = this.id;
        } else if (this.parentType == 'list') {
            data.idList = this.id;
        } else {
            data.idEntity = this.id;
        }

        for (var i = 0; i < items.length; i++) {
            data.commands.push({
                Id: items[i].Id > 0 ? items[i].Id : 0,
                Name: items[i].Name,
                Type: items[i].Type,
                Description: items[i].Description,
                Condition: items[i].Condition,
                IdDbConn: items[i].IdDbConn,
                Content: items[i].Content,
                RunType: items[i].RunType,
                PermReqType: items[i].PermReqType
            });
        }

        $.ajax({
            type: "POST",
            url: this.commandSaveUrl,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result.jsonEntity != null) {
                    var items = JSON.parse(result.jsonEntity);
                    this.commandSource = this._createGridDatasource(items, {
                        pageSize: 10,
                        page: 1
                    });
                    $('#' + this.commandsListId).data('kendoGrid').setDataSource(this.commandSource);
                }
            },
            error: function (e) {
                toastr.error(e.responseText, this._getResource('Error'));
            }
        });
    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }
}